import { ArrowLeft, Home, LockKeyhole } from "lucide-react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Topbar from "../components/Topbar";
import { useAuth } from "../context/AuthContext";

const DEFAULT_MESSAGE = "У вас нет прав для посещения данной страницы";

export default function ForbiddenPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const detail = searchParams.get("detail")?.trim() || DEFAULT_MESSAGE;

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 via-white to-indigo-50/40 text-slate-900">
      {user && <Topbar />}

      <main className="mx-auto flex min-h-[calc(100vh-88px)] w-full max-w-5xl items-center justify-center px-6 py-16">
        <section className="relative w-full overflow-hidden rounded-[2rem] border border-white/80 bg-white/90 px-6 py-10 text-center shadow-[0_24px_70px_rgba(79,70,229,0.14)] backdrop-blur sm:px-10 sm:py-14">
          <div className="pointer-events-none absolute -left-24 -top-24 h-56 w-56 rounded-full bg-indigo-100/70 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-28 -right-24 h-64 w-64 rounded-full bg-purple-100/70 blur-3xl" />

          <div className="relative mx-auto flex max-w-2xl flex-col items-center">
            <div className="mb-6 inline-flex h-20 w-20 items-center justify-center rounded-3xl bg-gradient-to-br from-indigo-600 to-purple-600 text-white shadow-[0_20px_40px_rgba(99,102,241,0.35)]">
              <LockKeyhole size={34} />
            </div>

            <div className="mb-3 inline-flex rounded-full border border-indigo-100 bg-indigo-50 px-4 py-1.5 text-sm font-semibold text-indigo-700">
              Ошибка 403
            </div>

            <h1 className="text-3xl font-bold tracking-tight text-slate-950 sm:text-4xl">
              Доступ ограничен
            </h1>
            <p className="mt-4 max-w-xl text-base leading-7 text-slate-600">
              {detail}
            </p>

            <div className="mt-8 flex w-full flex-col justify-center gap-3 sm:w-auto sm:flex-row">
              <Link
                to="/"
                className="inline-flex items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-indigo-600 to-purple-600 px-6 py-3 text-sm font-semibold text-white shadow-[0_18px_32px_rgba(99,102,241,0.28)] transition hover:translate-y-[-1px] hover:brightness-105"
              >
                <Home size={18} />
                На главный экран
              </Link>
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-6 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
              >
                <ArrowLeft size={18} />
                Вернуться назад
              </button>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
